import React from 'react';
import { Slider, Select, MenuItem, Button } from '@mui/material';
import styles from './FinanceCalculatorCard.module.scss';

export default function FinanceCalculatorCard() {
  const [age, setAge] = React.useState(48);
  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const [distance, setDistance] = React.useState(8000);
  const handleDistanceChange = (event) => {
    setDistance(event.target.value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.stepIndicator}>
          <div className={styles.step}>
            <div className={`${styles.stepCircle} ${styles.stepInactive}`}>
              <span>1</span>
            </div>
            <div className={styles.stepText}>
              <div className={styles.stepTitle}>SELECT MODEL</div>
            </div>
          </div>
          <div className={styles.step}>
            <div className={`${styles.stepCircle} ${styles.stepActive}`}>
              <span>2</span>
            </div>
            <div className={styles.stepText}>
              <div className={styles.stepTitle}>FINANCE CALCULATOR</div>
            </div>
          </div>
        </div>
        <div className={styles.poweredBy}>Powered by NewVehicle</div>
      </div>
      <div className={styles.content}>
        <div className={styles.item}>
          <span className={`${styles.miniItem} ${styles.title}`}>Your Deposit</span>
          <span className={styles.miniItem}>€ 4,500</span>
          <div className={styles.miniItem}>
            <Slider
              sx={{
                padding: '0 !important',
                '& .MuiSlider-root': {
                  padding: '0 !important',
                },
                '& .MuiSlider-rail': {
                  backgroundColor: '#ececf0 !important',
                  height: '14px',
                  opacity: 1,
                },
                '& .MuiSlider-track': {
                  backgroundColor: '#030213',
                  height: '14px',
                  border: 'none',
                },
                '& .MuiSlider-thumb': {
                  backgroundColor: '#fff',
                  border: '1px solid #030213',
                  height: '15px',
                  width: '15px',
                },
                '& .MuiSlider-mark': {
                  backgroundColor: '#ececf0 !important',
                  opacity: 1,
                },
                '& .MuiSlider-markActive': {
                  backgroundColor: '#ececf0 !important',
                  opacity: 1,
                },
              }}
              defaultValue={60}
              aria-label="Default"
            />
          </div>
        </div>
        <div className={styles.item}>
          <span className={`${styles.miniItem} ${styles.title}`}>Agreement Term</span>
          <div className={styles.miniItem}>
            <Select
              value={age}
              onChange={handleChange}
              displayEmpty
              sx={{
                width: '100%',
                backgroundColor: '#ececf0',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '& .MuiSelect-select': {
                  padding: '2px 10px',
                },
                '& .MuiInputBase-input': {
                  padding: '2px 10px',
                  fontSize: '0.766rem',
                },
              }}
              MenuProps={{
                disableScrollLock: true,
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                PaperProps: {
                  sx: {
                    margin: '8px 0',
                    marginLeft: '0',
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0',
                    maxHeight: '200px',
                    '& .MuiMenuItem-root': {
                      fontSize: '0.766rem',
                      margin: '2px 8px',
                      borderRadius: '4px',
                      paddingLeft: '5px',
                      minHeight: 'auto',
                      padding: '4px 8px 4px 5px',
                    },
                    '& .MuiMenuItem-root.Mui-selected': {
                      backgroundColor: '#ececf0 !important',
                      '&:hover': {
                        backgroundColor: '#ececf0 !important',
                      },
                    },
                    '& .MuiMenuItem-root:hover': {
                      backgroundColor: '#ececf0',
                    },
                  },
                },
              }}
            >
              <MenuItem value={24}>24 month</MenuItem>
              <MenuItem value={36}>36 month</MenuItem>
              <MenuItem value={48}>48 month</MenuItem>
              <MenuItem value={60}>60 month</MenuItem>
            </Select>
          </div>
        </div>
        <div className={styles.item}>
          <span className={`${styles.miniItem} ${styles.title}`}>Annual Mileage</span>
          <div className={styles.miniItem}>
            <Select
              value={distance}
              onChange={handleDistanceChange}
              displayEmpty
              sx={{
                width: '100%',
                backgroundColor: '#ececf0',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '& .MuiSelect-select': {
                  padding: '0px 10px',
                },
                '& .MuiInputBase-input': {
                  padding: '2px 10px',
                  fontSize: '0.766rem',
                },
              }}
              MenuProps={{
                disableScrollLock: true,
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                PaperProps: {
                  sx: {
                    margin: '8px 0',
                    marginLeft: '0',
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0',
                    maxHeight: '200px',
                    '& .MuiMenuItem-root': {
                      fontSize: '0.766rem',
                      margin: '2px 8px',
                      borderRadius: '4px',
                      paddingLeft: '5px',
                      minHeight: 'auto',
                      padding: '4px 8px 4px 5px',
                    },
                    '& .MuiMenuItem-root.Mui-selected': {
                      backgroundColor: '#ececf0 !important',
                      '&:hover': {
                        backgroundColor: '#ececf0 !important',
                      },
                    },
                    '& .MuiMenuItem-root:hover': {
                      backgroundColor: '#ececf0',
                    },
                  },
                },
              }}
            >
              <MenuItem value={5000}>5000</MenuItem>
              <MenuItem value={8000}>8000</MenuItem>
              <MenuItem value={10000}>10000</MenuItem>
              <MenuItem value={12000}>12000</MenuItem>
              <MenuItem value={15000}>15000</MenuItem>
              <MenuItem value={20000}>20000</MenuItem>
            </Select>
          </div>
        </div>
        <div className={styles.item}>
          <Button
            className={styles.miniItem}
            variant="outlined"
            sx={{
              backgroundColor: '#ffffff',
              border: '1px solid #000000',
              borderRadius: '4px',
              color: '#333333',
              padding: '8px 16px',
              fontSize: '0.875rem',
              fontWeight: 500,
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#000000 !important',
                border: '1px solid #000000 !important',
                color: '#ffffff !important',
              },
            }}
          >
            Update Quotes
          </Button>
        </div>
      </div>
    </div>
  );
}
